import Button from '../Button'
import {useQuery} from 'react-query'
import {Dispatch, SetStateAction} from 'react'
import React, {useState, useEffect} from 'react'
import {GetDedications} from '@/services/api/personalize/GetDedications'
import {toast} from 'react-hot-toast'
import CustomToast from '../CustomToast'
import {useRouter} from 'next/router'

interface Props {
  product: any
  setInputDedication: Dispatch<SetStateAction<string>>
  inputDedication: any
  SubmitChange?: any
  close?: any
  setOption: Dispatch<SetStateAction<number | undefined>>
  gender: string
  setDedicationModal?: any,
  updateProductData?:any,
  handleSave?:any
  isEdit?:any,
  markOptionCompleted?:any
  nameFromPersonalize?:any
}

export default function Dedications({
  product,
  setInputDedication,
  inputDedication,
  SubmitChange,
  gender,
  setOption,
  setDedicationModal,
  close = undefined,
  updateProductData,
  handleSave,
  isEdit,
  markOptionCompleted,
  nameFromPersonalize
}: Props) {
  const {data, isLoading} = useQuery(['dedications', gender], GetDedications)
  const [wordCount, setWordCount] = useState(0)
  const [charCount, setCharCount] = useState(0)
  const limit = 400
  const [tempDedication, setTempDedication] = React.useState(inputDedication)
  const [selectedId, setSelectedId] = useState<number | 'custom' | null>(null)
  const router = useRouter()
  const url_inputs =
    router.query.inputs != undefined
      ? JSON.parse(router.query.inputs as string)
      : {
          name: product.replace_name,
          first_name: product.replace_name.split(' ')[0],
          age: '٨',
          init: product.replace_name.charAt(0),
        }
        const checkReplaceName =
          isEdit === '1'
            ? product?.name
            : (nameFromPersonalize !== undefined && nameFromPersonalize !== '')
              ? nameFromPersonalize
              : product?.replace_name;

  React.useEffect(() => {
    setTempDedication(inputDedication || '');
  }, [inputDedication]);

  useEffect(() => {
  if (data && selectedId != null) {
    const selectedDedication = data.find((d: any) => d.id === selectedId);
    if (selectedDedication) {
      const newText = selectedDedication.dedication.replace('{basmti}', checkReplaceName);
      setTempDedication(newText);
      setInputDedication(
        newText.replace(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
          '',
        )
      );
    }
  }
}, [checkReplaceName]);

  // Initialize selected dedication when data loads or inputDedication changes
  useEffect(() => {
    if (data && inputDedication) {
      // Check if the current inputDedication matches any predefined dedication
      const matchedDedication = data.find((dedication: any) => {
        const fullText = dedication.dedication.replace('{basmti}', checkReplaceName);
        return fullText === inputDedication;
      });

      if (matchedDedication) {
        setSelectedId(matchedDedication.id);
      } else if (inputDedication) {
        // If it doesn't match any predefined dedication, select custom
        setSelectedId('custom');
      }
    }
  }, [data, inputDedication, checkReplaceName]);

  React.useEffect(() => {
    const words = tempDedication.split(' ')
    setCharCount(tempDedication.length)
  }, [tempDedication])

  const UpdateDedication = (id: number) => {
    const newText = data
      .filter((x: any) => x.id == id)[0]
      .dedication.replace('{basmti}', checkReplaceName)

    setTempDedication(newText)
    setInputDedication(
      newText.replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
        '',
      ),
    )
  }

  return (
    <div className="personalization-content dedication lg:flex lg:flex-col gap-2 dedications items-center w-full lg:p-8 lg:gap-6">
      <h2 className="text-xl font-semibold hidden"> اكتب رسالتك الخاصة</h2>
      <div className='hidden lg:flex w-full items-center justify-between'>
        <h2 className="text-xl font-semibold">أضف إهداء مميز مجانًا</h2>
        <button 
            className="bg-[#93A3B03D] text-xl p-2 rounded-md" 
            onClick={()=>{
              setDedicationModal(false);
            }}
          >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.23742 7.00023L13.7439 1.88765C14.0857 1.57026 14.0857 1.05566 13.7439 0.738291C13.4021 0.420895 12.8479 0.420895 12.5061 0.738291L7.00022 5.8514L1.49438 0.738291C1.15257 0.420895 0.598385 0.420895 0.256602 0.738291C-0.0851811 1.05569 -0.0852084 1.57028 0.256602 1.88765L5.76302 7.00023L0.256602 12.1128C-0.0852084 12.4302 -0.0852084 12.9448 0.256602 13.2622C0.598412 13.5796 1.15259 13.5796 1.49438 13.2622L7.00022 8.14905L12.5061 13.2622C12.8479 13.5796 13.4021 13.5796 13.7438 13.2622C14.0857 12.9448 14.0857 12.4302 13.7438 12.1128L8.23742 7.00023Z" fill="black"/>
          </svg>
        </button>
      </div>
      <div className="dedications-options flex flex-col my-6 items-center w-full gap-6">
        {isLoading ? 
          (
          <div className='flex-1 overflow-y-auto px-4 py-6 bg-[#FFFCEB] flex items-center justify-center gap-4'>
            <div className="w-6 h-6 border-4 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
              <h2 className="text-lg font-semibold leading-none">تحميل التخصيصات المحددة مسبقًا...</h2>
            </div>
          )
          : 
          (
          <div className="dedication-options-bg py-2 px-2 w-full rounded-md border">
            <p className="text-primary text-md font-normal text-start">قوالب اهداءات</p>
            {data?.length != 0 ? (
              <ul className="mt-2">
              {data?.map((dedication: any, index: number) => {
                const isSelected = selectedId === dedication.id;
                const fullText = dedication.dedication.replace('{basmti}', checkReplaceName);

                return (
                  <li
                    key={dedication.id}
                    className="flex flex-col gap-2 bg-white rounded-md py-2 px-2 lg:p-2 justify-between mt-2 border cursor-pointer"
                  >
                    <div
                      className="flex flex-row-reverse items-center justify-end gap-2"
                      onClick={() => {
                        setSelectedId(dedication.id);
                        setTempDedication(fullText);
                        setInputDedication(fullText);
                        UpdateDedication(dedication.id);
                      }}
                    >
                      <label htmlFor={`dedication-${dedication.id}`} className="text-sm text-success">
                        {dedication.name}
                      </label>
                      <label htmlFor={`dedication-${dedication.id}`} className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="dedication"
                          id={`dedication-${dedication.id}`}
                          checked={isSelected}
                          onChange={() => {}}
                          className="hidden peer"
                        />
                        <div className="w-4 h-4 rounded-full border-2 border-success bg-success flex items-center justify-center peer-checked:bg-success relative">
                          {isSelected && (
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                              <path
                                d="M1 5.19922L3.70368 8.14736C4.1159 8.59686 4.83101 8.57584 5.21611 8.10291L11 1"
                                stroke="#00214D"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          )}
                        </div>
                      </label>
                    </div>

                    {isSelected && (
                      <textarea
                        rows={6}
                        value={tempDedication}
                        onChange={(e) => {
                          const value = e.target.value;
                          setTempDedication(value);
                          setInputDedication(
                            value.replace(
                              /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
                              '',
                            )
                          );
                        }}
                        style={{
                          direction: /^[a-zA-Z0-9\s.,!?;:'"\-()]*$/.test(tempDedication) ? 'ltr' : 'rtl',
                        }}
                        className="border border-[#93A3B03D] w-full font-medium placeholder:font-light placeholder:opacity-70 p-4 text-sm focus:ring-1 transition duration-200 focus:ring-black focus:border-transparent rounded-lg text-right"
                        placeholder="اكتب اهداء قصير..."
                      />
                    )}
                  </li>
                );
              })}
            </ul>
            ): (
              <p className='text-primary text-sm font-medium'>لا يوجد تخصيص محدد مسبقًا للمنتج</p>
            )}
          </div>
          )
          }
              <li
                className="flex flex-col gap-2 bg-white rounded-md py-2 px-2 lg:p-2 justify-between mt-2 cursor-pointer w-full"
              >
                <div
                  className="flex flex-row-reverse items-center justify-end gap-2"
                  onClick={() => {
                    setSelectedId('custom');
                    setTempDedication(inputDedication || '');
                    setInputDedication(inputDedication || '');
                  }}
                >
                  <label htmlFor="dedication-custom" className="text-sm text-primary">
                    اكتب الاهداء بنفسك
                  </label>
                  <label htmlFor="dedication-custom" className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="dedication"
                      id="dedication-custom"
                      checked={selectedId === 'custom'}
                      onChange={() => {}}
                      className="hidden peer"
                    />
                    <div className="w-4 h-4 rounded-full border-2 border-success bg-success flex items-center justify-center peer-checked:bg-success relative">
                      {selectedId === 'custom' && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path
                            d="M1 5.19922L3.70368 8.14736C4.1159 8.59686 4.83101 8.57584 5.21611 8.10291L11 1"
                            stroke="#00214D"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      )}
                    </div>
                  </label>
                </div>

                {selectedId === 'custom' && (
                  <>
                  <textarea
                    rows={6}
                    value={tempDedication}
                    onChange={(e) => {
                      const value = e.target.value;
                      setTempDedication(value);
                      setInputDedication(
                        value.replace(
                          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
                          '',
                        )
                      );
                    }}
                    style={{
                      direction: /^[a-zA-Z0-9\s.,!?;:'"\-()]*$/.test(tempDedication) ? 'ltr' : 'rtl',
                    }}
                    className="border border-[#93A3B03D] w-full font-medium placeholder:font-light placeholder:opacity-70 p-4 text-sm focus:ring-1 transition duration-200 focus:ring-black focus:border-transparent rounded-lg text-right"
                    placeholder="اكتب اهداء قصير..."
                  />
                  <p
                    className={`text text-right text-sm font-semibold  opacity-80 ${
                      limit - charCount < 0 ? 'text-red' : 'text-[#93A3B0CC]'
                    }`}>
                    حرفًا متبقيًا {limit - charCount}
                  </p>
                  </>
                )}
              </li>
      </div>
      <div className="hidden lg:block mt-4 lg:mt-0 w-full">
        <div className="self-end mt-4 lg:mt-0">
          <Button
            type="button"
            bg="primary"
            onClick={() => {
              if (limit - charCount < 0) {
                toast.custom((t) => (
                  <CustomToast
                    t={t}
                    message={'الإهداء الشخصي طويل جدًا.يرجى الالتزام بكتابة أقل من 200 حرف لعرض الاهداء بشكل اجمل'}
                    type="error"
                  />
                ));
                return;
              }

              if (tempDedication == '') {
                toast.custom((t) => (
                  <CustomToast t={t} message={'الرجاء إدخال الإهداء قبل الاستمرار'} type="error" />
                ));
                return;
              }

              const cleanedDedication = tempDedication.replace(
                /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
                '',
              );

              setInputDedication(cleanedDedication);
              updateProductData({ dedication: cleanedDedication });
              markOptionCompleted('dedication', true);
              handleSave();
              setDedicationModal(false);
            }}
            classes={['block', 'py-3', 'w-full']}>
            {'متابعة'}
          </Button>
        </div>
      </div>
    </div>
  )
}